if (!customElements.get("carousel-slider")) {
  customElements.define(
    "carousel-slider",
    class CarouselSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.carousel = this.querySelector('[class*="grid-carousel"]');
        this.initialize();
      }

      initialize() {
        // 1. Get Autoplay Settings
        const autoplayAttr = this.getAttribute("data-autoplay");
        let autoPlayConfig = false;

        if (autoplayAttr === "true") {
            const speed = parseInt(this.getAttribute("data-speed"), 10);
            autoPlayConfig = speed ? speed * 1000 : 5000; 
        } else if (autoplayAttr) {
            autoPlayConfig = parseInt(autoplayAttr, 10);
        }

        const groupCells = this.getAttribute("data-group-cells") !== "false";
        const wrapAround = this.getAttribute("data-wrap-around") === "true";

        // 2. CRITICAL FIX FOR MOBILE:
        // We must use 'setProperty' with 'important' to override the theme's 
        // default mobile CSS which often forces 'display: flex !important'.
        if (this.carousel) {
            this.carousel.style.setProperty("display", "block", "important");
        }

        // 3. Initialize Flickity
        this.flickity = new Flickity(this.carousel, {
          autoPlay: autoPlayConfig,
          cellAlign: "left",
          groupCells: groupCells,
          contain: true,
          resize: true,
          draggable: true,
          prevNextButtons: false, // Often cleaner to hide buttons on mobile
          fade: false,
          cellSelector: ".grid-item",
          initialIndex: 0,
          pageDots: false,
          wrapAround: wrapAround,
          accessibility: false,
          watchCSS: false, // Force slider to run on mobile
        });

        // 4. Handle Slide Change Events
        this.flickity.on("change", (index) => {
          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
             publish(PUB_SUB_EVENTS.sliderSlideChange, {
               id: this.getAttribute("id"),
               index,
             });
          }
        });
      }
    },
  );
}

if (!customElements.get("carousel-navigation")) {
  customElements.define(
    "carousel-navigation",
    class CarouselNavigation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init(retry = 1, maxRetry = 3) {
        if (retry === maxRetry) {
          return;
        }

        const id = this.getAttribute("for");
        this.carouselComponent = document.querySelector(`#${id}`);
        this.wrap = this.dataset.wrap === "true";

        if (!this.carouselComponent || !this.carouselComponent.flickity) {
          setTimeout(() => {
            this.init(retry + 1);
          }, 350);
          return;
        }

        this.flickity = this.carouselComponent.flickity;
        this.buttonPrev = this.querySelector(".js-prev");
        this.buttonNext = this.querySelector(".js-next");

        if (this.buttonPrev) {
          this.buttonPrev.addEventListener("click", (event) => {
            event.preventDefault();
            this.flickity.previous();
          });
        }

        if (this.buttonNext) {
          this.buttonNext.addEventListener("click", (event) => {
            event.preventDefault();
            this.flickity.next();
          });
        }

        this.flickity.on("select", () => {
          this.enableButton(this.buttonPrev);
          this.enableButton(this.buttonNext);

          if (this.wrap) {
            return;
          }

          if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
            this.disableButton(this.buttonPrev);
          } else if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
            this.disableButton(this.buttonNext);
          }
        });
      }

      enableButton(button) {
        if (!button) return;
        button.classList.remove("pill-nav-item-disabled");
        button.classList.remove("focus-none");
        button.setAttribute("aria-disabled", "false");
      }

      disableButton(button) {
        if (!button) return;
        button.classList.add("pill-nav-item-disabled");
        button.classList.add("focus-none");
        button.setAttribute("aria-disabled", "true");
      }
    },
  );
}